import React from 'react';
import classnames from 'classnames';

const ToggleButton = ({ issue, type, expanded, onExpandPosts }) => {
  const { name: issueName, tghpwipIssuesTaxonomyColor: issueColor } = issue;
  const isSpecial = type === 'special' || type === 'symposium';
  const isStandard = type === 'standard';

  return (
    <div
      className={classnames([
        `issue-section__toggle`,
        isStandard && issueColor && `issue-section__toggle--${issueColor}`,
      ])}
    >
      <button
        className={`issue-section__toggle-button`}
        onClick={onExpandPosts}
        key="issue-section-toggle"
      >
        {!expanded ? 'View' : 'Hide'} {isSpecial && 'all'} {issueName} articles
      </button>
    </div>
  );
};

export default ToggleButton;
